import { Commit } from 'vuex';
import { EquipementInterventionsState } from '@/modules/Preventif/store/modules/state';

export interface EquipementInterventionsActionType {
    commit: Commit;
    state: EquipementInterventionsState;
}

export enum EquipementInterventionsActions {
    GET_EQUIPEMENT_INTERVENTIONS = 'GET_EQUIPEMENT_INTERVENTIONS',
    GET_ALL_EQUIPEMENT_INTERVENTIONS = 'GET_ALL_EQUIPEMENT_INTERVENTIONS',
    RESET_ALL_EQUIPEMENT_INTERVENTIONS = 'RESET_ALL_EQUIPEMENT_INTERVENTIONS',
}
